let components = [];

export function ProjectsServices(rootDom) {
    const selector = {
        ACTIVE: '_active',
    };
    const $navs = $('.js-projects-services-nav', rootDom).children();
    const $contents = $('.js-projects-services-content', rootDom).children();

    if (!$navs.length) return;

    // HANDLERS
    $navs.on('mouseenter focus', onEnter);

    // PRIVATE
    function onEnter(e) {
        const index = $(e.currentTarget).index();

        $navs
            .removeClass(selector.ACTIVE)
            .eq(index)
            .addClass(selector.ACTIVE);
        $contents
            .removeClass(selector.ACTIVE)
            .eq(index)
            .addClass(selector.ACTIVE);
    }

    // PUBLIC
    function destroy() {
        $navs.off('click', onEnter);
    }

    return {
        destroy
    };
}

// Инициализация компонента
function init(e, data) {
    const pageContainerDom = data.next.container;

    components = Array.from(pageContainerDom.querySelectorAll('.js-projects-services')).map(ProjectsServices);
}

App.W.on("barba:afterEnter", init);
App.W.on('barba:leave', () => {
    if (components.length) {
        components.forEach(component => component.destroy());
        components = [];
    }
});



// WEBPACK FOOTER //
// ./_src/js/modules/ProjectsServices.js